module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event/younite-event-ko-0a44db37ad9c8283bacd30af8272f16c.png";